import { createContext } from 'react';
import { Spacing } from '../../types';

interface GridContextProps {
  spacing?: Spacing;
}
const GridContext = createContext({} as GridContextProps);

if (process.env.NODE_ENV !== 'production') {
  GridContext.displayName = 'GridContext';
}

export default GridContext;
